module.exports = __webpack_public_path__ + "img/c5202009.1a3f9fd9.jpg";